var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container', _vm._isMobile() ? 'mobile' : ''],style:({
    background: _vm.tenantConfig.homeBgColor,
    'background-image': 'url(' + _vm.tenantConfig.homeBg + ')',
    'background-repeat': _vm.tenantConfig.homeBgRepeat,
  })},[_c('div',{staticClass:"wide"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }